import { FeedbackMapper } from '../mapper/FeedbackMapper';

export const feedbackMapper = new FeedbackMapper();
